import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Button,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Flex,
  Empty,
} from "antd";
import { UserAccountStore } from "../../../store";
import type { DatePickerProps, RangePickerProps } from "antd/es/date-picker";
import locale from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "./index.css";

import "dayjs/locale/zh-cn";

function UpdateOrAdd() {
  const form = Form.useFormInstance();

  const { Option } = Select;

  const getFormData = (changeValue: any, allValues: any) => {
    if (changeValue.expiredTime) {
      changeValue.expiredTime = changeValue.expiredTime.format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }
    allValues.displayName = UserAccountStore.lookPower.displayName;
    UserAccountStore.setLookPower({ ...allValues, ...changeValue });
  };
  const submitPower = async () => {
    if (UserAccountStore.addOrUpdateModal.update) {
      UserAccountStore.editUserAccount(UserAccountStore.lookPower);
      UserAccountStore.addOrUpdateModal.close();
    } else {
      if (
        UserAccountStore.lookPower.displayName &&
        UserAccountStore.lookPower.groupList &&
        UserAccountStore.lookPower.phoneNumber
      ) {
        UserAccountStore.inviteUserAccount(UserAccountStore.lookPower);
        UserAccountStore.addOrUpdateModal.close();
      }
    }
  };

  const onChange = (value: any, dateString: any) => {
    if (value === null) {
      UserAccountStore.lookPower.expiredTime = null;
    }
    if (dateString) {
      UserAccountStore.lookPower.expiredTime = dateString;
    }
  };
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <Modal
        width={520}
        centered
        title={UserAccountStore.addOrUpdateModal.update ? "编辑" : "邀请新用户"}
        open={UserAccountStore.addOrUpdateModal.isOpen}
        destroyOnClose={true}
        onCancel={() => UserAccountStore.addOrUpdateModal.close()}
        footer={null}
      >
        {
          <Form
            form={form}
            labelCol={{ flex: "110px" }}
            labelWrap
            initialValues={UserAccountStore.lookPower}
            wrapperCol={{ flex: 1 }}
            onValuesChange={getFormData}
            style={{marginTop:'20px'}}
          >
            <Flex vertical>
            {UserAccountStore.addOrUpdateModal.update && (
              <Form.Item
                label="账户编号"
                name="no"
                rules={[{ required: true }]}
              >
                <Input style={{ width: "330px" }} disabled />
              </Form.Item>
            )}
            {UserAccountStore.addOrUpdateModal.add && (
              <Form.Item
                label="手机号"
                name="phoneNumber"
                rules={[{ required: true, message: "请输入手机号" }]}
              >
                <Input placeholder="用户唯一标识" style={{ width: "330px" }} count={{show:true,max:50}}/>
              </Form.Item>
            )}

              <Form.Item
                label="昵称"
                name="displayName"
                rules={[{ required: true, message: "请输入昵称" }]}
              >
                <Input placeholder="用户内部名称" style={{ width: "330px" }} showCount maxLength={50}/>
              </Form.Item>

              <ConfigProvider renderEmpty={tableEmptyRender}>
            {UserAccountStore.addOrUpdateModal.add && (
              <Form.Item
                label="关联用户组"
                name="groupList"
                rules={[{ required: true, message: "请选择关联用户组" }]}
              >
                <Select placeholder="用户初始用户组" style={{ width: "330px" }} onChange={UserAccountStore.handleChange} mode="multiple">
                  {Array.from(UserAccountStore.manageAccountList)
                    ? Array.from(UserAccountStore.manageAccountList).map(
                        (value: any, index: any) => {
                          return (
                            <Option value={value.no} key={value.no}>
                              {value.displayName}
                            </Option>
                          );
                        }
                      )
                    : ""}
                </Select>
              </Form.Item>
            )}</ConfigProvider>
            {UserAccountStore.addOrUpdateModal.add && (
              <Form.Item label="有效期" name="expiredTime1" style={{width:'640px'}}>
                <ConfigProvider locale={locale}>
                  <DatePicker
                    style={{ width: "330px" }}
                    value-format="YYYY-MM-DD"
                    onChange={onChange}
                    placeholder="请选择有效期，不填代表永久有效" 
                    onOk={(
                      value:
                        | DatePickerProps["value"]
                        | RangePickerProps["value"]
                    ) => {
                      console.log("onOk: ", value);
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            )}
            {UserAccountStore.addOrUpdateModal.update && (
              <Form.Item
                label="有效期"
                name="expiredTime1"
              >
                <ConfigProvider locale={locale}>
                  <DatePicker
                    defaultValue={UserAccountStore.lookPower.expiredTime?dayjs(UserAccountStore.lookPower.expiredTime):undefined}
                    value-format="YYYY-MM-DD"
                    onChange={onChange}
                    placeholder="请选择有效期，不填代表永久有效" 
                    onOk={(
                      value:
                        | DatePickerProps["value"]
                        | RangePickerProps["value"]
                    ) => {
                      console.log("onOk: ", value);
                    }}
                    style={{ width: "330px" }}
                    allowClear
                  />
                </ConfigProvider>
              </Form.Item>
            )}
            <Form.Item style={{ textAlign: 'right' }} wrapperCol={{ span: 18, offset: 6 }}>
              <Space>
              <Button htmlType="reset" onClick={() => UserAccountStore.addOrUpdateModal.close()}>取消</Button>
              <Button type="primary" htmlType="submit" onClick={submitPower}>
                确定
              </Button>
              </Space>
            </Form.Item>
            </Flex>
          </Form>
        }
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
